import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { subDays } from 'date-fns';
// local
// lib
import { _val, zeroTime } from 'app/lib/helper';
import { isFormValid } from 'app/lib/formHelper';
// view
import DatePicker from 'app/ui/commons/datepicker/DatePicker';
import DropdownPatient from 'app/ui/commons/DropdownPatient';
// actions
import { search } from 'app/redux/actions/editConfirm/data';
// consts
import { STATUS as PATIENT_STATUS } from 'salvus-shared/consts/patient';

class EditConfirmFilters extends Component {
    constructor(props) {
        super(props);
        const today = zeroTime(new Date());
        const values = {
            dateFrom: subDays(today, 2).getTime(),
            dateTo: today.getTime(),
        };
        this.state = {
            form: this.initForm(values),
            errors: {},
        };
    }

    initForm(values = {}) {
        return {
            dateFrom: _val(values.dateFrom, null),
            dateTo: _val(values.dateTo, null),
            patientId: _val(values.patientId, null),
        };
    }

    validateForm(form, field) {
        const errors = {};

        if (!field || field === 'dateFrom' || field === 'dateTo') {
            const dateFrom = form.dateFrom;
            const dateTo = form.dateTo;
            if (_.isNil(dateFrom)) {
                errors['dateFrom'] = 'O campo DE é obrigatório.';
            } else if (dateFrom > new Date()) {
                errors['dateFrom'] = 'O campo DE não pode ser maior que hoje.';
            } else if (dateFrom > dateTo) {
                errors['dateFrom'] = 'O campo DE não pode ser maior que o ATÉ.';
            } else {
                errors['dateFrom'] = undefined;
            }
            if (_.isNil(dateTo)) {
                errors['dateTo'] = 'O campo ATÉ é obrigatório.';
            } else if (dateTo > new Date()) {
                errors['dateTo'] = 'O campo ATÉ não pode ser maior que hoje.';
            } else if (dateTo < dateFrom) {
                errors['dateTo'] = 'O campo DE não pode ser maior que o ATÉ.';
            } else {
                errors['dateTo'] = undefined;
            }
        }
        return errors;
    }

    onChange = field => value => {
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    componentDidMount = () => this.onClickSearch();

    onChangePatient = (e, { value }) => this.onChange('patientId')(value);

    // handle clicks into the search button
    onClickSearch = () => {
        // check if there is any error in the form
        const { form } = this.state;
        const errors = this.validateForm(form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            return;
        }
        const query = _.assign({}, form);
        this.props.dispatch(search(query));
    };

    render() {
        const { form } = this.state;
        return (
            <div className="body-header">
                <div className="flex">
                    <div>Período</div>
                    <DatePicker value={form.dateFrom} onChange={this.onChange('dateFrom')} error={this.hasError('dateFrom')} />
                    <div>à</div>
                    <DatePicker value={form.dateTo} onChange={this.onChange('dateTo')} error={this.hasError('dateTo')} />
                    <DropdownPatient
                        placeholder="Selecione o paciente"
                        onChange={this.onChangePatient}
                        filter={[PATIENT_STATUS.INITIALIZED, PATIENT_STATUS.DEACTIVATED]}
                    />
                </div>
                <Button onClick={this.onClickSearch}>PESQUISAR</Button>
            </div>
        );
    }
}

EditConfirmFilters.propTypes = {
    dispatch: PropTypes.func,
};

export default connect()(EditConfirmFilters);
